export const TASK_TYPES = {
    DOCUMENT: "document",
    TEST: "quiz",
    QUESTIONNAIRE: "questionnaire",
    COURSE: "course",
};